var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "currentColor",
    style: {
      color: "#51c394"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.126.293a1 1 0 0 1 1.414 0l5.834 5.833A1 1 0 0 1 11.96 7.54L7.833 3.414v9.253a1 1 0 1 1-2 0V3.414L1.707 7.54A1 1 0 0 1 .293 6.126L6.126.293Z",
    clipRule: "evenodd"
  })));
};
export default SvgArrowUp;